import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { postEmbedUrl } from 'src/hooks/metabaseEmbed/request';

export function useMetabaseEmbed() {
  const [iframeUrl, setIframeUrl] = useState('');
  const darkmode = localStorage.getItem('@polichat/darkmode') === 'true';
  const user = useSelector((state: any) => state.general?.user);

  useEffect(() => {
    const fetchIframeUrl = async () => {
      try {
        const { iframe_url } = await postEmbedUrl({ customer_id: user?.customer_id });
        const finalUrl = `${iframe_url}${darkmode ? '#theme=night&bordered=true&titled=true' : ''}`;
        setIframeUrl(finalUrl);
      } catch (err) {
        console.error('Error fetching Metabase URL:', err);
      }
    };

    if (user) {
      fetchIframeUrl();
    }
  }, [user, darkmode]);

  return { iframeUrl };
}